<div class="point__createdBy__field" data-test="createdBy">
  <label ppTooltip class="point__createdBy__label" ppTitle="Created By">
    {{ 'created_by' | ppTranslate }}
  </label>

  <div class="pointCF__content">
    @if (users?.includes(ppCreatedById)) {
      @if (allUsers[ppCreatedById]?.avatarPublicUrl) {
        <img
          ppTooltip
          ppImage
          class="timeline__avatar"
          draggable="false"
          [src]="allUsers[ppCreatedById]?.avatarPublicUrl"
          [ppTitle]="allUsers[ppCreatedById]?.userName"
          [ppMobileTooltip]="true"
          />
      }
      @if (!allUsers[ppCreatedById]?.avatarPublicUrl) {
        <img
          ppTooltip
          class="timeline__avatar"
          draggable="false"
          [src]="EIconPath.PLACEHOLDER_USER"
          [ppTitle]="allUsers[ppCreatedById]?.userName"
          [ppMobileTooltip]="true"
          />
      }
    }

    @if (!users?.includes(ppCreatedById)) {
      @if (ppCreatedByAvatar) {
        <img
          ppTooltip
          ppImage
          class="timeline__avatar timeline__avatar--disabled"
          draggable="false"
          [ppSecureSrc]="'api/v1/images/' + ppCreatedByAvatar + '/file/size/square/40'"
          [ppTitle]="ppCreatedByName + ' (deleted)'"
          [ppMobileTooltip]="true"
          />
      }
      @if (!ppCreatedByAvatar) {
        <img
          ppTooltip
          class="timeline__avatar timeline__avatar--disabled"
          draggable="false"
          [src]="EIconPath.PLACEHOLDER_USER"
          [ppTitle]="ppCreatedByName + ' (deleted)'"
          [ppMobileTooltip]="true"
          />
      }
    }
  </div>
</div>
